import axios from 'axios';

// 会话失效（token 过期 / 被服务端拒绝）时的统一处理：
// 之前只是接口静默 401，页面照样渲染外壳，结果后台只剩一张空表格。
const SESSION_EXPIRED_EVENT = 'shuadan:session-expired';

// 登录/注册接口自己的 401 表示“账号密码错误”，不能当成会话过期
const AUTH_URLS = ['/api/auth/login', '/api/auth/register'];

export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const onSessionExpired = (handler) => {
  window.addEventListener(SESSION_EXPIRED_EVENT, handler);
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
};

const expireSession = () => {
  if (!localStorage.getItem('token')) return;
  clearSession();
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

// 全局只装一次，避免组件重复挂载时叠加拦截器
export const installSessionGuard = () => {
  // Express 的 res.json 会带 ETag 但不带 Cache-Control，浏览器会启发式缓存接口 JSON，
  // 换 token 后可能还在重放上一次缓存的 401。用 GET 加时间戳参数强制回源；
  // 不能用自定义请求头（如 Cache-Control）——后端 CORS 只放行 Content-Type/Authorization，
  // 多一个头就会让预检失败，POST 请求根本发不出去。
  axios.interceptors.request.use((config) => {
    if ((config.method || 'get').toLowerCase() === 'get') {
      config.params = { ...(config.params || {}), _: Date.now() };
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const url = error.config?.url || '';
      if (error.response?.status === 401 && !AUTH_URLS.some((path) => url.includes(path))) {
        expireSession();
      }
      return Promise.reject(error);
    }
  );
};
